import React, { useEffect, useState } from "react";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/login-logo.svg";
import { InputLabel, Input } from "@mui/material";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserType } from "../../../Services/Signup/SignupApi/SignupApi";
import "./Signupone.css";
import HorizontalLinearStepper from "../../Stepper/Stepper";

function SignuponeComp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.fetchUserType);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    userType: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    image: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    // Clear errors when the user starts typing or interacting
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error for the field being modified
    }));

    // Save to localStorage
    localStorage.setItem("signupFormData", JSON.stringify(updatedData));
    // localStorage.setItem("signUpEmail", updatedData.email);
  };

  useEffect(() => {
    const savedData = localStorage.getItem("signupFormData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      const validImageTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!validImageTypes.includes(file.type)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          image: "Please upload a valid image file (JPEG, PNG, GIF).",
        }));
        return;
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        image: "", // Clear any previous error
      }));
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
    }
  };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length <= 3) {
      value = value;
    } else if (value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
        6,
        10
      )}`;
    }

    setFormData((prevData) => ({
      ...prevData,
      phoneNumber: value,
    }));

    // Clear the phone number error when the user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      phoneNumber: "", // Clear phone number error when user starts typing
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (field) => !formData[field]?.trim();

    if (isEmpty("userType")) newErrors.userType = "User Type is required";
    if (isEmpty("firstName")) newErrors.firstName = "First Name is required";
    if (isEmpty("lastName")) newErrors.lastName = "Last Name is required";

    if (isEmpty("phoneNumber")) {
      newErrors.phoneNumber = "Phone Number is required";
    } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber =
        "Phone Number must be in the format (123) 456-7890";
    }

    if (isEmpty("email")) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid Email Address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      localStorage.setItem("signupStepOneComplete", "true");
      navigate("/signuptwo", { state: formData });
    }
  };

  // useEffect(() => {
  //   navigate(stepRoutes[activeStep]);
  // }, [activeStep, navigate]);


  useEffect(() => {
    dispatch(fetchUserType());
  }, [dispatch]);

  const handleLogingroute = () => {
    navigate("/login");
  };
  return (
    <>
      <section className="login-page-one signuponepage">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6">
              <div className="login-right-block logo-left-block mb-4">
                <div className="login-logoimg text-center">
                  <img src={login_logo} alt="login-logo"></img>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image email-verify-blk">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                    <h5>Let's Setup Your Operating Agreement</h5>
                    <p>
                      Elevate your business insights with precision. Log in to
                      discover and refine your Ideal Customer Profiles
                      effortlessly.
                    </p>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-md-6 login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img src={login_logo} alt="login-logo" />
                  </Link>
                </div>
                <div className="stepper mt-4 mb-3 d-flex justify-content-between align-items-center">
                  {/* <div className="stepper-innner">
                                  <Link
                                    to="/signupone"
                                    className=" d-flex flex-column align-items-center gap-1"
                                  >
                                    <div className="stepper-dot-fade active"></div>
                                    <div className="step-no-fade active">Step 1</div>
                                  </Link>
                                </div>
                                <div className="stepper-line active"></div>
                                <div className="stepper-innner">
                                  <a className=" d-flex flex-column align-items-center gap-1">
                                    <div className="stepper-dot-fade active"></div>
                                    <div className="step-no-fade active">Step 2</div>
                                  </a>
                                </div> */}
                  <HorizontalLinearStepper activeStepProp={0} />
                </div>
              </div>
              <div className="stepper stepper-responsive mb-3 d-flex justify-content-between align-items-center">
                {/* <div className="stepper-innner">
                                  <Link
                                    to="/signupone"
                                    className=" d-flex flex-column align-items-center gap-1"
                                  >
                                    <div className="stepper-dot-fade active"></div>
                                    <div className="step-no-fade active">Step 1</div>
                                  </Link>
                                </div>
                                <div className="stepper-line active"></div>
                                <div className="stepper-innner">
                                  <a className=" d-flex flex-column align-items-center gap-1">
                                    <div className="stepper-dot-fade active"></div>
                                    <div className="step-no-fade active">Step 2</div>
                                  </a>
                                </div> */}
                <HorizontalLinearStepper activeStepProp={0} />
              </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  <h1 className="text-center mt-2">Sign Up for HOA Verified</h1>
                  <div className="form-login text-left">
                    <div className="mb-4 select-dropdown">
                      <InputLabel htmlFor="user-type-select">
                        User Type<span>*</span>
                      </InputLabel>
                      <select
                        className="user-type-dropdown"
                        id="user-type-select"
                        defaultValue=""
                        name="userType"
                        value={formData.userType}
                        onChange={handleInputChange}
                      >
                        <option value="" selected disabled>
                          Select User Type
                        </option>
                        {data?.data
                          ?.filter(
                            (role) =>
                              role.role_name !== "Vendor" &&
                              role.role_name !== "Realtor"
                          )
                          ?.map((role) => (
                            <option key={role.id} value={role.id}>
                              {role.role_name}
                            </option>
                          ))}
                      </select>
                      {errors.userType && (
                        <span className="error-text">{errors.userType}</span>
                      )}
                    </div>
                    <div className="mb-4 name-container">
                      <div className="name-field">
                        <InputLabel htmlFor="first-name">
                          First Name<span>*</span>
                        </InputLabel>
                        <Input
                          className="first-name-input"
                          id="first-name"
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={handleInputChange}
                        />
                        {errors.firstName && (
                          <span className="error-text">{errors.firstName}</span>
                        )}
                      </div>
                      <div className="name-field">
                        <InputLabel htmlFor="last-name">
                          Last Name<span>*</span>
                        </InputLabel>
                        <Input
                          className="last-name-input"
                          id="last-name"
                          type="text"
                          placeholder="Last Name"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                        />
                        {errors.lastName && (
                          <span className="error-text">{errors.lastName}</span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 phone-container">
                      <InputLabel htmlFor="phone-number">
                        Phone Number<span>*</span>
                      </InputLabel>
                      <div className="phone-input-group">
                        <Input
                          className="phone-number-input"
                          id="phone-number"
                          type="text"
                          placeholder="(123) 456-7890"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handlePhoneNumberChange}
                        />
                        <br></br>
                      </div>
                      {errors.phoneNumber && (
                        <span className="error-text">{errors.phoneNumber}</span>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Email Address<span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <span className="error-text">{errors.email}</span>
                      )}
                    </div>
                    <div className="mb-4">
                      <div className="file-upload">
                        <label htmlFor="fileInput">
                          Profile Image or Company Logo (Optional)
                        </label>
                        <div className="input-container">
                          <input
                            type="file"
                            id="fileInput"
                            name="image"
                            onChange={handleFileChange}
                            accept="image/*" // Restricts the file picker to image files
                          />
                          <span className="custom-file-label">
                            <span>Choose File</span>
                            <i
                              className="fa fa-paperclip"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        {errors.image && (
                          <span className="error-text">{errors.image}</span>
                        )}
                      </div>
                    </div>

                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Continue</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Already have an account?{" "}
                        <a href="" onClick={handleLogingroute}>
                          Log In
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default SignuponeComp;
